e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                // Variants is not yet ready for production.
                // e4.product.variants.init();
            } );
        }
        jQuery( '.js-e-product-images, #js-e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            jQuery( event.target ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
                jQuery( event.target ).trigger( 'click' );
            } );
        } );
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );

            var jProduct = jQuery( '.js-e-product' ),
                strProductId = jProduct.data( 'productId' ),
                strVariantId = jProduct.data( 'variantId' ),

                strDataPropertyPath = [
                    strProductId,
                    'variantCombinations',
                    strVariantId
                ].join('.'),

                strMainDataPropertyPath = [
                    strProductId
                ].join('.');
            
            
            var data = null;
            if (jProduct.data( 'variantId' ) !== "") {
                data = e4.data.get(strDataPropertyPath)   
            } else {
                data = e4.data.get(strMainDataPropertyPath)
            }

            e4.cart.ajax( {
                method: 'GET'
            }, function ( jsonData ) {
                e4.cart.disableAddToCartButtonIfLowOnStock(jsonData);
            } );


            if (data.stock.quantity > 0) {
                if (data.IsPreorder === false) {
                    jQuery('.js-lilly-cart-quantity').attr('data-stock', data.stock.quantity);
                } else {
                }
            } else {
                jQuery('.js-lilly-cart-quantity').attr('data-stock', "");
            }

            if (data.stock.quantity < parseInt(jQuery('.js-lilly-cart-quantity').val())) {
                jQuery('.js-product-ispreorder-orderlinefield').val('true')
                jQuery('.js-lilly-preorder-info').removeClass("d-none")
            } else {
                jQuery('.js-product-ispreorder-orderlinefield').val('')
                jQuery('.js-lilly-preorder-info').addClass("d-none")
            }
            
        } );
        jQuery( '.js-e-product-form' ).on('input', '.js-lilly-cart-quantity', function( event ){
            e4.product.collieRound( event );
        });

        jQuery( '.js-product-detail-container, .js-product-detail-carousel-container' ).on("builded.e4.variants", function( event ){
            e4.product.variant.variants.setMaxStockOnQuantityInput();
            jQuery( document ).find( '.popover.show').remove();
            jQuery( function () {
                jQuery( '[data-toggle="popover"]' ).popover( {
                    trigger: 'manual',
                    placement: 'top'
                } );
            } );
            jQuery( document ).on( 'show.bs.popover', function ( event ) {
                jQuery( event.target ).addClass( 'has-popover-shown' );
            } );
            jQuery( document ).on( 'hidden.bs.popover', function ( event ) {
                jQuery( event.target ).removeClass( 'has-popover-shown' );
            } );
        });
        
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
        if ( jQuery( '.js-e-product-favorite-list-form' ).length > 0 ) {
            e4.product.favoritelist.bindEvents();
        }
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
            
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    },
    favoritelist: {
        bindEvents: function () {
            jQuery( '.js-e-product-favorite-list-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
            } ).on( 'change', '.js-e-favorite-list', function ( event ) {
                e4.product.favoritelist.toggleList( event.target );
            } );
        },
        toggleList: function ( domInput ) {
            var jInput = jQuery( domInput );
            if ( jInput.prop( 'checked' ) === true ) {
                e4.product.favoritelist.addToList( jInput );
            }
            else {
                e4.product.favoritelist.removeFromList( jInput );
            }
        },
        addToList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-add' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        },
        removeFromList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-remove' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        }
    },
    collieInfoMsg: function( event ) {
        var eventTarget = event.target,
            jEventTarget;
        if(eventTarget === undefined){
            jEventTarget = event;
        } else {
            jEventTarget = jQuery(eventTarget)
        }
        e4.product.popover.show(jEventTarget);
    },
    collieRound: function( event ){
        
        var jInput = jQuery(event.target),
            intQuantityStock = jInput.data('stockminuswhatsincart'),
            intOutputValue = jInput.val();
        
        if(isNaN(intOutputValue)){
            intOutputValue = 1;
        }
        if((parseInt(intQuantityStock) < parseInt(intOutputValue))){
            jInput.val(parseInt(intQuantityStock));
            e4.product.collieInfoMsg(event);
        } else {
            e4.product.popover.hide( event.target );
        }
    },
    popover: {
        timeoutDuration: 4000,
        timeout: null,
        show: function ( domPopoverTarget ) {
            jQuery( '.has-popover-shown' ).each( function ( intIndex, domElement ) {
                if ( domPopoverTarget !== domElement ) {
                    jQuery( domElement ).popover( 'hide' );
                }
            } );
            e4.product.popover.timer.clear();
            e4.product.popover.timer.set( domPopoverTarget );
            jQuery( domPopoverTarget ).popover( 'show' );
        },
        hide: function ( domPopoverTarget ) {
            e4.product.popover.timer.clear();
            jQuery( domPopoverTarget ).popover( 'hide' );

        },
        timer: {
            set: function ( domPopoverTarget ) {
                e4.product.popover.timer.clear();
                e4.product.popover.timeout = setTimeout( function () {
                    e4.product.popover.hide( domPopoverTarget );
                }, e4.product.popover.timeoutDuration );
            },
            clear: function () {
                if ( e4.product.popover.timeout ) {
                    e4.product.popover.timeout = clearTimeout( e4.product.popover.timeout );
                }
            }
        }
    }
};
